<template>
    <div>
        this is the fuckin admin dashboard
    </div>
</template>

<script>
export default {
    name: "AdminDashboard"
}
</script>